import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=0cddb462&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/footer.scss?vue&type=style&index=0&id=0cddb462&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cddb462",
  null
  
)

export default component.exports